export default __webpack_public_path__ + "static/media/PEPSICO Logo (1).16a2622b.png";